class ModalContainer extends HHBaseElement {
  constructor() {
    super()
    this.$title = this.querySelector('[slot="title"]')
    this.$content = this.querySelector('[slot="content"]')
    this.slidePanel = this.querySelector('slide-panel')
    this.closeSlideout = this.querySelector('.js-close-slideout')
    this.close = this.close.bind(this)

    this._openSlideout = this._openSlideout.bind(this)
  }

  connectedCallback() {
    this._attachListeners()
    this.slidePanel?.click()
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  close() {
    this.slidePanel.open = false
    this._reset()
  }

  _attachListeners() {
    document.addEventListener('modal-container::close', this.close)
  }

  _removeListeners() {
    document.removeEventListener('modal-container::close', this.close)
  }

  _reset() {
    this.$content.innerHTML = ''
    this.$title.innerHTML = ''
  }

  _setInnerHTML = function (elm, html) {
    try {
      elm.innerHTML = html
      this._onProductRenderComplete()
      Array.from(elm.querySelectorAll('script')).forEach((oldScript) => {
        const newScript = document.createElement('script')
        Array.from(oldScript.attributes).forEach((attr) =>
          newScript.setAttribute(attr.name, attr.value)
        )
        newScript.appendChild(document.createTextNode(oldScript.innerHTML))
        oldScript.parentNode.replaceChild(newScript, oldScript)
      })
    } catch (error) {
      console.error(error)
    }
  }

  _openSlideout() {
    this.slidePanel.open = true
    this.slidePanel?.setupFocusTrap()
    this.closeSlideout?.focus()
  }
}

window.customElements.define('modal-container', ModalContainer)
